export default "__VITE_ASSET__BMefJXyD__"